import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { debounce } from 'lodash'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectWidget',
  props: {
  value: {},
  filter: Object,
  config: Object,
  resetTrigger: Boolean,
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const model = ref(props.value)
const filterLabel = props.config.label || 'label'

const update = (value: any) => {
  if (Array.isArray(value)) {
    const normalizedTo = value.map(el => el[filterLabel])

    emit('update:modelValue', normalizedTo)
  } else {
    emit('update:modelValue', value.label)
  }
}

const debounceUpdate = debounce(update, 100)

const normalizeFrom = (val: any): string[] => {
  if (Array.isArray(val)) {
    return val
  } else {
    return [val]
  }
}

const setValueFromUrl = (val: any) => {
  if (!val) return

  const normalizedValue = normalizeFrom(val)
  const items: string[] = props.filter.values

  const checked = items.filter(el => normalizedValue.find(v => v === el[filterLabel]))

  if (!checked) return

  if (props.config.multiple) {
    model.value = checked
  } else {
    model.value = checked[0]
  }
}

watch(() => props.value, () => {
  setValueFromUrl(props.value)
}, { immediate: true })

// watch(() => props.resetTrigger, () => model.value = null)

const __returned__ = { props, emit, model, filterLabel, update, debounceUpdate, normalizeFrom, setValueFromUrl, ref, watch, get debounce() { return debounce } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})